<template>
  <svg :key="icon" class="icon">
    <use :href="iconKey" :xlink:href="iconKey" />
  </svg>
</template>

<script setup lang="ts">
import iconService from 'commons/icon/service/iconService.ts';
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
});

const iconKey = computed(() => `${iconService.getIconRef()}#${props.icon}`);
</script>
